import type { AdminParentOrganizationSelectDto, CompanyType } from '@@types/api.types';
import { routes } from '@routes';
import { getCompanyTypeLabel } from '@utils/company.util';

export const formatOrganizationOptionSubtitle = (
  organization: Pick<AdminParentOrganizationSelectDto, 'id' | 'type'>,
): string => `${formatOrganizationTypeLabel(organization.type)} - ${formatOrganizationShortId(organization.id)}`;

export const formatOrganizationShortId = (id: string): string => id.split('-')[0] ?? id;
export const formatOrganizationTypeLabel = (type: CompanyType): string => getCompanyTypeLabel(type);

export const getAdminOrganizationHref = (organizationId: string): string =>
  `${routes.adminOrganizations.path}?orgId=${encodeURIComponent(organizationId)}`;
